import request from "../Tools/request/request";

// 应用服务咨询管理-列表
export function getServiceList(data) {
    return request({
        url: "/builder/app-server/list",
        method: "post",
        data,
    });
}

// 应用服务咨询管理-中止
export function getServiceStop(data) {
    return request({
        url: "/builder/app-server/operate",
        method: "post",
        data,
    });
}

// 应用服务咨询管理-审核
export function getServiceReview(data) {
    return request({
        url: "/builder/app-server/operate",
        method: "post",
        data,
    });
}

// 实例资源管理-列表
export function getResourceList(data) {
    return request({
        url: "/builder/server-instance/list",
        method: "post",
        data,
    });
}

// 数据库接入管理-列表
export function getDatabaseList(data) {
    return request({
        url: "/builder/database/list",
        method: "post",
        data,
    });
}

// 数据库接入管理-配置
export function getDatabaseSetting(data) {
    return request({
        url: "/builder/database/config",
        method: "post",
        data,
    });
}

